"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var CapacityInsightsEntity_1 = __importDefault(require("./Entity/CapacityInsightsEntity"));
var DATE_FORMAT = 'YYYY-MM-DD';
var CapacityInsightsApi = /** @class */ (function () {
    function CapacityInsightsApi(session) {
        this.capacityInsightsEntity = new CapacityInsightsEntity_1.default(session);
    }
    CapacityInsightsApi.prototype.getInsightCount = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.capacityInsightsEntity.getInsightCount(params)];
            });
        });
    };
    CapacityInsightsApi.prototype.getInsights = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.capacityInsightsEntity.getInsights(params)];
            });
        });
    };
    CapacityInsightsApi.prototype.updateInsightDone = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.capacityInsightsEntity.updateInsightDone(params)];
            });
        });
    };
    CapacityInsightsApi.prototype.getInsightsForDates = function (dates, teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var sortedDates, dateStart, dateEnd, insights, insightsByDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (dates.length === 0) {
                            return [2 /*return*/, {}];
                        }
                        sortedDates = __spreadArray([], __read(dates), false).sort(function (a, b) { return a.valueOf() - b.valueOf(); });
                        dateStart = sortedDates[0].format(DATE_FORMAT);
                        dateEnd = sortedDates[sortedDates.length - 1].format(DATE_FORMAT);
                        return [4 /*yield*/, this.getInsights({
                                teamId: teamId,
                                dateStart: dateStart,
                                dateEnd: dateEnd
                            })];
                    case 1:
                        insights = _a.sent();
                        insightsByDate = {};
                        dates.forEach(function (date) {
                            var dateString = date.format(DATE_FORMAT);
                            insightsByDate[dateString] = insights.filter(function (insight) {
                                var insightDate = (0, moment_1.default)(insight.scheduled_date).format(DATE_FORMAT);
                                return insightDate === dateString;
                            });
                        });
                        return [2 /*return*/, insightsByDate];
                }
            });
        });
    };
    CapacityInsightsApi.prototype.getInsightCountsForTeams = function (teamIds, dateStart, dateEnd) {
        return __awaiter(this, void 0, void 0, function () {
            var BATCH_SIZE, countsMap, i, batch, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (teamIds.length === 0) {
                            return [2 /*return*/, new Map()];
                        }
                        BATCH_SIZE = 100;
                        countsMap = new Map();
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < teamIds.length)) return [3 /*break*/, 4];
                        batch = teamIds.slice(i, i + BATCH_SIZE);
                        return [4 /*yield*/, this.getInsightCount({
                                teamIds: batch,
                                dateStart: dateStart.format(DATE_FORMAT),
                                dateEnd: dateEnd.format(DATE_FORMAT)
                            })];
                    case 2:
                        response = _a.sent();
                        response.forEach(function (item) {
                            countsMap.set(item.team_id, item.insight_count);
                        });
                        _a.label = 3;
                    case 3:
                        i += BATCH_SIZE;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, countsMap];
                }
            });
        });
    };
    CapacityInsightsApi.prototype.submitInsightFeedback = function (insightId, body) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.capacityInsightsEntity.submitInsightFeedback(insightId, body)];
            });
        });
    };
    CapacityInsightsApi.prototype.findLatestInsightFeedback = function (insightIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.capacityInsightsEntity.findLatestInsightFeedback({ insight_ids: insightIds })];
            });
        });
    };
    CapacityInsightsApi.prototype.deleteInsightFeedbacks = function (insightId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.capacityInsightsEntity.deleteInsightFeedbacks(insightId)];
            });
        });
    };
    return CapacityInsightsApi;
}());
exports.default = CapacityInsightsApi;
//# sourceMappingURL=CapacityInsightsApi.js.map